import { OrderEmailNotificationsFrequencySettingsType } from 'services'
import {
  ORDER_ATTACHMENTS_CARGO_PHOTOS_READ,
  ORDER_ATTACHMENTS_CARGO_PHOTOS_WRITE, ORDER_ATTACHMENTS_CONFIRMATION_READ,
  ORDER_ATTACHMENTS_CONFIRMATION_WRITE, ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_READ,
  ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_WRITE, ORDER_ATTACHMENTS_OTHER_DOCUMENTS_READ,
  ORDER_ATTACHMENTS_OTHER_DOCUMENTS_WRITE
} from 'context/auth'

export const IntermediatePointType = {
  FerryPassage: 'FERRY_PASSAGE',
  CustomsControl: 'CUSTOMS_CONTROL',
  Custom: 'CUSTOM'
}

export const DeliveryPointType = {
  Loading: 'LOADING',
  Unloading: 'UNLOADING'
}

export const attachmentTypes = [
  {
    value: 'DELIVERY_DOCUMENTS',
    label: 'deliveryDocuments',
    requiredPrivilege: {
      write: ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_WRITE,
      read: ORDER_ATTACHMENTS_DELIVERY_DOCUMENTS_READ,
    }
  },
  {
    value: 'CARGO_PHOTOS', label: 'cargoPhotos', requiredPrivilege: {
      write: ORDER_ATTACHMENTS_CARGO_PHOTOS_WRITE,
      read: ORDER_ATTACHMENTS_CARGO_PHOTOS_READ,
    }
  },
  {
    value: 'OTHER_DOCUMENTS', label: 'otherDocuments', requiredPrivilege: {
      write: ORDER_ATTACHMENTS_OTHER_DOCUMENTS_WRITE,
      read: ORDER_ATTACHMENTS_OTHER_DOCUMENTS_READ,
    }
  },
  {
    value: 'ORDER_CONFIRMATION', label: 'orderConfirmation', requiredPrivilege: {
      write: ORDER_ATTACHMENTS_CONFIRMATION_WRITE,
      read: ORDER_ATTACHMENTS_CONFIRMATION_READ,
    }
  }
]

export const ScheduledEmailsFrequencyOptions = {
  Never: {
    label: 'form.emailNotificationSetting.sendInterval.never',
    frequencySettingsType: OrderEmailNotificationsFrequencySettingsType.Never,
    sendIntervalHours: null
  },
  Interval2h: {
    label: 'form.emailNotificationSetting.sendInterval.interval2h',
    frequencySettingsType: OrderEmailNotificationsFrequencySettingsType.Interval,
    sendIntervalHours: 2
  },
  Interval4h: {
    label: 'form.emailNotificationSetting.sendInterval.interval4h',
    frequencySettingsType: OrderEmailNotificationsFrequencySettingsType.Interval,
    sendIntervalHours: 4
  },
  Interval6h: {
    label: 'form.emailNotificationSetting.sendInterval.interval6h',
    frequencySettingsType: OrderEmailNotificationsFrequencySettingsType.Interval,
    sendIntervalHours: 6
  },
  MorningAndEvening: {
    label: 'form.emailNotificationSetting.sendInterval.morningAndEvening',
    frequencySettingsType: OrderEmailNotificationsFrequencySettingsType.MorningAndEvening,
    sendIntervalHours: null
  }
}

export const OrderTimeZones = [
  {
    id: 'Europe/Lisbon',
    name: 'WET/WEST'
  },
  {
    id: 'Europe/Warsaw',
    name: 'CET/CEST'
  },
  {
    id: 'Europe/Kiev',
    name: 'EET/EEST'
  },
  {
    id: 'Europe/Moscow',
    name: 'MSK'
  }
]
